import React from 'react'
import { jt, t } from 'ttag'

import { DeleteResourceModal } from 'components/modals/common/DeleteResourceModal/DeleteResourceModal'

export const DeleteCandidateModal = ({
  name,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => {
  const candidate = <strong key="candidate">{name}</strong>

  return (
    <DeleteResourceModal
      alert={jt`You are deleting ${candidate}.`}
      message={t`Are you sure you want to delete?`}
      title={t`Delete candidate`}
      {...{ onCancel, onClose, onConfirm, isOpen }}
    />
  )
}
